<div>
  <div  class="progress-title" >
    <span>{{title}}</span>
    <span>{{progress}}{{unit}}</span>
  </div>
  <div>
    <mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>
  </div>
</div>
